/**
 * @generated SignedSource<<6971d492e4780bdf0aa7033a702ea6cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "programType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showHistory"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vendoraccountId"
},
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountname",
        "variableName": "accountName"
      },
      {
        "kind": "Variable",
        "name": "endTs",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "programtype",
        "variableName": "programType"
      },
      {
        "kind": "Variable",
        "name": "showhistory",
        "variableName": "showHistory"
      },
      {
        "kind": "Variable",
        "name": "startTs",
        "variableName": "startDate"
      },
      {
        "kind": "Variable",
        "name": "vendoraccountid",
        "variableName": "vendoraccountId"
      }
    ],
    "concreteType": "PayoutInfosConnection",
    "kind": "LinkedField",
    "name": "getcreatepayoutinfo2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PayoutInfo",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerPid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "programName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "programDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "programType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payoutStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payoutCreatedDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "periodStartTs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "periodEndTs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvedDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvedBy",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePayoutsQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreatePayoutsQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "fb43b49aef7b0271f2fb945c18e5c151",
    "id": null,
    "metadata": {},
    "name": "CreatePayoutsQuery",
    "operationKind": "query",
    "text": "query CreatePayoutsQuery(\n  $vendoraccountId: UUID!\n  $startDate: Datetime\n  $endDate: Datetime\n  $accountName: String\n  $showHistory: Int\n  $programType: Int\n  $first: Int\n  $offset: Int\n) {\n  getcreatepayoutinfo2(vendoraccountid: $vendoraccountId, startTs: $startDate, endTs: $endDate, accountname: $accountName, showhistory: $showHistory, programtype: $programType, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      resellerPid\n      programName\n      programDescription\n      programType\n      resellerAccountId\n      resellerAccountName\n      payoutStatus\n      payoutCreatedDate\n      periodStartTs\n      periodEndTs\n      approvedDate\n      approvedBy\n    }\n  }\n}\n"
  }
};
})();

node.hash = "209fab60da97a6af8abda999acf01cc8";

module.exports = node;
